import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { FormContainer } from './containers/FormContainer';
import { trackLoginNeedHelp } from '../../utils/tracking';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { HelpContainer } from '../HelpContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RestoreView(_ref) {
  var source = _ref.source;
  var handleHelpClick = React.useCallback(function () {
    return trackLoginNeedHelp(source);
  }, [source]);
  return /*#__PURE__*/_jsxs(ViewContainer, {
    children: [/*#__PURE__*/_jsx(TitleContainer, {}), /*#__PURE__*/_jsx(SubtitleLayout, {
      children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 email, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0443\u043A\u0430\u0437\u0430\u043B\u0438 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438"
    }), /*#__PURE__*/_jsx(FormContainer, {}), /*#__PURE__*/_jsx(HelpContainer, {
      onClick: handleHelpClick
    })]
  });
}